import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { IconButton } from "@mui/material";
import { Typography } from '@mui/material';
import DrawerMenu from '../DrawerMenu/DrawerMenu';
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Image from '../Image/Image';

import './Header.scss';

function Header({ showBackBtn, hideBackBtnLabel, pageTitle, pageTitleIconURL }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  function goBack() {
    navigate(-1);
  }

  function toggleDrawer() {
    setOpen(!open);
  };

  return (
    <div className="app-header">
      {showBackBtn && (
        <IconButton onClick={goBack} className="back-btn">
          <ArrowBackIcon className="back-btn-arrow-icon" />
          {!hideBackBtnLabel && (
            <Typography variant="span" component="span" className="back-btn-text">
              Voltar
            </Typography>
          )}
        </IconButton>
      )}
      {pageTitleIconURL ? (
        <Image src={pageTitleIconURL} className="page-title-icon"/>
      ) : pageTitle ? (
        <Typography className="page-title">{pageTitle || ''}</Typography>
      ) : (
        <></>
      )}
      {!showBackBtn && (
        <IconButton onClick={toggleDrawer}>
          <MenuIcon className="toggle-btn" />
        </IconButton>
      )}
      <DrawerMenu
        toggleDrawer={toggleDrawer}
        open={open}
        className="hamburguer-btn"
      />
    </div>
  );
}

export default Header;